module.exports = __webpack_public_path__ + "img/pit_fight.f7bbf3f0.jpg";